import React, { useEffect, useState } from 'react';

const ImageComponent = (props) => {
  const { id, rectProps, formatProps } = props;
  const { image, graphicFormattingScale } = formatProps;
  const scaleFactor = graphicFormattingScale;
  const rectFactor = parseFloat(
    (rectProps.width / rectProps.height).toFixed(2),
  );
  const [imageFactor, setImageFactor] = useState(1);
  const [coordinates, setCoordinates] = useState({ x: 0, y: 0 });

  const handleImageFactor = (image) => {
    if (image.width || image.height) {
      setImageFactor(parseFloat((image.width / image.height).toFixed(2)));
    } else {
      setImageFactor(1);
    }
  };

  const getX = () => {
    if (rectFactor > imageFactor) {
      switch (image.horizontalAlignment) {
        case 'LEFT': {
          return (rectProps.width - rectProps.width * scaleFactor) / 2;
        }
        case 'CENTER': {
          return (rectProps.width - (rectProps.height * scaleFactor) * imageFactor) / 2;
        }
        case 'RIGHT': {
          return (
            rectProps.width - (rectProps.height * scaleFactor) * imageFactor - ((rectProps.width - rectProps.width * scaleFactor) / 2)
          );
        }
        default: {
          break;
        }
      }
    }
    return (rectProps.width - rectProps.width * scaleFactor) / 2;
  };

  const getY = () => {
    if (rectFactor < imageFactor) {
      switch (image.verticalAlignment) {
        case 'TOP': {
          return (rectProps.height - rectProps.height * scaleFactor) / 2;
        }
        case 'MIDDLE': {
          return (rectProps.height - (rectProps.width * scaleFactor) / imageFactor) / 2;
        }
        case 'BOTTOM': {
          return rectProps.height - (rectProps.width * scaleFactor) / imageFactor - ((rectProps.height - rectProps.height * scaleFactor) / 2);
        }
        default: {
          break;
        }
      }
    }
    return (rectProps.height - rectProps.height * scaleFactor) / 2;
  };

  const handleCoordinatesChange = () => {
    const x = getX();
    const y = getY();

    setCoordinates({ x, y });
  };

  useEffect(() => {
    const img = new Image();

    img.src = image.href;
    img.onload = function () {
      handleImageFactor(img);
    };
  }, [image.href]);

  useEffect(() => {
    handleCoordinatesChange();
  }, [
    imageFactor,
    rectProps.x,
    rectProps.y,
    rectProps.width,
    rectProps.height,
    image.horizontalAlignment,
    image.verticalAlignment,
    scaleFactor,
  ]);

  const width = rectFactor > imageFactor ? undefined : rectProps.width * scaleFactor;
  const height = rectFactor > imageFactor ? rectProps.height * scaleFactor : undefined;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={rectProps.width}
      height={rectProps.height}
      x={rectProps.x}
      y={rectProps.y}
    >
      <image
        id={id}
        href={image.href}
        width={width}
        height={height}
        x={coordinates.x}
        y={coordinates.y}
      />
    </svg>
  );
};

export default ImageComponent;
